import {
  createResource,
  postResource,
} from '@resource/resource'

import { prefixAPI } from '@resource/api'

const MODEL_PREFIX = 'cart'

const CART_RETRIEVE = prefixAPI('/retrieve/', MODEL_PREFIX)
const CART_CHANGE = prefixAPI('/change/', MODEL_PREFIX)
const CART_APPLY_PROMOCODE = prefixAPI('/promo-code/apply/', MODEL_PREFIX)
const CART_REMOVE_PROMOCODE = prefixAPI('/promo-code/remove/', MODEL_PREFIX)

export const cartRetrieveResource = createResource(CART_RETRIEVE)
export const cartChangeResource = createResource(CART_CHANGE, postResource)
export const cartPromoCodeApplyResource = createResource(CART_APPLY_PROMOCODE, postResource)
export const cartPromoCodeRemoveResource = createResource(CART_REMOVE_PROMOCODE, postResource)
